import { Box, styled } from "@mui/material";

export const WelcomeAndIntructionsPopUpRoot = styled(Box)(({ theme }) => ({
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "2.5rem",
  padding: "3rem 2.5rem",
  border: `1px solid ${theme?.palette?.companyColors?.greyLight2}`,
  borderRadius: theme?.borderRadius?.medium,
  background: `rgba(${theme?.palette?.companyColors?.neutralRGB}, 0.75)`,
  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    alignItems: "center",
  },
  [theme.breakpoints.up("lg")]: {
    gap: "3rem",
    justifyContent: "center",
    padding: "7.5rem 5rem",
  },
  [theme.breakpoints.up("xl")]: {
    padding: "7.5rem 3rem",
  },
}));

export const WelcomeAndIntructionsPopUpItem = styled(Box)(({ theme }) => ({
  position: "relative",
  zIndex: 1,
  width: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  flexBasis: "100%",
  textAlign: "center",
  minWidth: "13vw",
  fontSize: "1.2rem",
  gap: "0.5rem",
  padding: 0,
  [theme.breakpoints.up("lg")]: { 
  gap: "1.5rem", 
  }, 
}));
